import { IonDate } from "../components/IonDate";

const CheckNotNull = Symbol('CheckNotNull');

class MemberType {
    public member_typeID: string = '';
    public label: string = '';
    public description: string = '';
    public datetime_created: Date | null = null;
    public datetime_updated: Date | null = null;
    public creatorID: string = '';
    public updaterID: string = '';

    constructor(
        member_typeID: string,
        label: string,
        description: string,
        datetime_created: string,
        datetime_updated: string,
        creatorID: string,
        updaterID: string
    ) {
        this.member_typeID = this[CheckNotNull](member_typeID) ? member_typeID : '';
        this.label = this[CheckNotNull](label) ? label : '';
        this.description = this[CheckNotNull](description) ? description : '';
        this.datetime_created = this[CheckNotNull](datetime_created) ? IonDate(datetime_created) : null;
        this.datetime_updated = this[CheckNotNull](datetime_updated) ? IonDate(datetime_updated) : null;
        this.creatorID = this[CheckNotNull](creatorID) ? creatorID : '';
        this.updaterID = this[CheckNotNull](updaterID) ? updaterID : '';
    }

    private [CheckNotNull] = (value: string) => {
        if(value && value != null && value != 'null' && value.length > 0)
            return true;
        else
            return false;
    }
}
export default MemberType